import type {
  HeaderLayoutContent,
  HeaderLayoutProps,
} from "scmp-app/components/header/layouts/types";
import {
  AbsoluteCenterFeatureContainer,
  CenterFeatureContainer,
  StyleLeftWrapper,
  StyleLogoWrapper,
} from "scmp-app/components/header/styles";

export const getStyleArticleLayout = ({
  config,
  features,
  initEdition,
  shouldSwap,
}: HeaderLayoutProps): HeaderLayoutContent => ({
  center: (
    <>
      <AbsoluteCenterFeatureContainer>
        {features.oneLineMenu({
          appBarVariant: config?.appBarVariant,
          hideOnSwap: true,
          initEdition,
          shouldSwap,
          showIn: "desktopUp",
        })}
        <StyleLogoWrapper>
          {features.styleLogoLink({
            hideOnSwap: true,
            shouldSwap,
            showIn: "mobileAndTablet",
          })}
          {features.styleTextLink({
            hideOnSwap: true,
            shouldSwap,
            showIn: "mobileAndTablet",
          })}
        </StyleLogoWrapper>
      </AbsoluteCenterFeatureContainer>
      <CenterFeatureContainer>
        {features.section({
          isMagazineStyle: true,
          shouldSwap,
          showIn: "desktopUp",
          showOnSwap: true,
        })}
        {features.articleHeadline({
          isMagazineStyle: true,
          shouldSwap,
          showIn: "desktopUp",
          showOnSwap: true,
        })}
      </CenterFeatureContainer>
    </>
  ),
  left: (
    <>
      {features.hamburgerMenu({ showIn: "mobileAndTablet" })}
      <StyleLeftWrapper>
        {features.styleLogoLink({
          hideOnSwap: true,
          shouldSwap,
          showIn: "desktopUp",
        })}
        {features.styleTextLink({
          shouldSwap,
          showIn: "mobileUp",
          showOnSwap: "mobileAndTablet",
        })}
        {features.search({
          hideOnSwap: true,
          shouldSwap,
          showDesktopDivider: true,
          showIn: "mobileUp",
        })}
      </StyleLeftWrapper>
    </>
  ),
  right: (
    <>
      {features.myNews({
        hideOnSwap: true,
        shouldSwap,
        showIn: "mobileUp",
      })}
      {features.dashboard({
        hideOnSwap: true,
        shouldSwap,
        showIn: "mobileUp",
      })}
      {features.share({
        shouldSwap,
        showIn: "mobileUp",
        showOnSwap: true,
      })}
      {features.bookmark({
        shouldSwap,
        showIn: "mobileUp",
        showOnSwap: true,
      })}
      {features.comment({
        shouldSwap,
        showIn: "mobileUp",
        showOnSwap: true,
      })}
    </>
  ),
});
